import { render, staticRenderFns } from "./HolderInfo.vue?vue&type=template&id=75f6d77c&scoped=true&"
import script from "./HolderInfo.vue?vue&type=script&lang=js&"
export * from "./HolderInfo.vue?vue&type=script&lang=js&"
import style0 from "./HolderInfo.vue?vue&type=style&index=0&id=75f6d77c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f6d77c",
  null
  
)

export default component.exports